module.exports = "/_next/static/images/Fidelity-147fc9a7e353e46da70a230dab8f7d1a.svg";